import {Component, Inject} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';

/**
 * "NAME THIS GROUP" (ITP-E-203-04, carbon's `groupNameDialog`): asked once the membership is settled, 420px, arriving
 * filled in with the picked names, so Create works without typing. Create stays disabled while the name is empty, and
 * closes with the trimmed name; Cancel closes with nothing.
 */
@Component({
  standalone: true,
  selector: 'chat-group-name-dialog',
  imports: [FormsModule, MatButtonModule, MatDialogModule],
  template: `
    <h2 mat-dialog-title>Name this group</h2>
    <mat-dialog-content>
      <input class="group-name" type="text" [(ngModel)]="name" aria-label="Group name" cdkFocusInitial
             (keydown.enter)="create()">
    </mat-dialog-content>
    <mat-dialog-actions class="group-name-actions">
      <button mat-button type="button" mat-dialog-close>Cancel</button>
      <button mat-flat-button color="primary" type="button" [disabled]="!name.trim()" (click)="create()">Create</button>
    </mat-dialog-actions>`,
  styleUrls: ['./group-name-dialog.component.scss']
})
export class GroupNameDialogComponent {
  name: string;

  constructor(private dialogRef: MatDialogRef<GroupNameDialogComponent, string>,
              @Inject(MAT_DIALOG_DATA) data: { name: string }) {
    this.name = data?.name || '';
  }

  create() {
    const name = this.name.trim();
    if (name) {
      this.dialogRef.close(name);
    }
  }
}
